module.exports = __webpack_public_path__ + "img/drink3.3215e710.png";